export type TicketSection = "tasks" | "files" | "comments";


type DeepLinkableNotification = {
  notification_type?: string | null;
  ticket?: { id?: string } | null;
  ticket_item?: { id?: string } | null;
};

export type TicketViewParams = {
  id: string;
  section?: TicketSection;
  taskId?: string;
};


const SECTION_BY_NOTIFICATION_TYPE: Record<string, TicketSection> = {
  TASK_ADDED: "tasks",
  FILE_UPLOADED: "files",
  COMMENT_ADDED: "comments",
};

export function getNotificationSection(
  notificationType: string | undefined | null
): TicketSection | undefined {
  if (!notificationType) return undefined;
  return SECTION_BY_NOTIFICATION_TYPE[notificationType];
}


export function resolveNotificationTarget(
  notification: DeepLinkableNotification
): TicketViewParams | null {
  const ticketId = notification.ticket?.id;
  if (!ticketId) return null;

  const section = getNotificationSection(notification.notification_type);
  if (!section) return { id: ticketId };

  const taskId = notification.ticket_item?.id;

  return taskId ? { id: ticketId, section, taskId } : { id: ticketId, section };
}
